module.exports = __webpack_public_path__ + "static/media/fairy_5.b48d8ad1.jpg";